import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import medagricycleLogo from '../aseets/images/medagricycle-logo-pro.png';
import primaLogo from '../aseets/images/prima.png';
import unionLogo from '../aseets/images/Union.png';
import primaLogoFooter from '../aseets/images/prima_logo.png';
import { useSettings } from '../contexts/SettingsContext';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { settings, isLoading } = useSettings();
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  };

  // Valeurs par défaut si les paramètres sont en cours de chargement
  const siteName = isLoading ? 'MedAgriCycle' : settings.siteName;
  const siteDescription = isLoading ? 'MedAgriCycle catalyzes circular urban agriculture across the Mediterranean by turning organic waste into value, conserving water, and empowering resilient food systems.' : (settings.siteDescription || 'MedAgriCycle catalyzes circular urban agriculture across the Mediterranean by turning organic waste into value, conserving water, and empowering resilient food systems.');
  const contactEmail = isLoading ? 'info@medagricycle.eu' : (settings.email || 'info@medagricycle.eu');
  const contactPhone = isLoading ? '+33 1 23 45 67 89' : (settings.phone || '+33 1 23 45 67 89');
  const facebookUrl = settings.facebook || '#';
  const twitterUrl = settings.twitter || '#';
  const linkedinUrl = settings.linkedin || '#';
  const instagramUrl = settings.instagram || '#';
  const youtubeUrl = settings.youtube || '#';

  return (
    <>
      <div style={{ 
        width: '100%', 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        marginTop: isMobile ? '60px' : '130px', 
        padding: isMobile ? '0 20px' : '0 16px',
        boxSizing: 'border-box'
      }}>
        <div style={{ 
          width: '100%', 
          maxWidth: isMobile ? '100%' : '800px', 
          display: 'flex', 
          flexDirection: isMobile ? 'column' : 'row',
          justifyContent: 'center', 
          alignItems: 'center',
          gap: isMobile ? '20px' : '40px'
        }}>
          <img
            alt="PRIMA Logo"
            src={primaLogo}
            style={{
              maxHeight: isMobile ? '120px' : '260px',
              width: '100%',
              maxWidth: isMobile ? '200px' : '250px',
              height: 'auto',
              objectFit: 'contain',
              filter: 'brightness(1.1)',
              marginRight: isMobile ? '0' : '40px'
            }}
          />
          <img
            alt="European Union Logo"
            src={unionLogo}
            style={{
              maxHeight: isMobile ? '120px' : '260px',
              width: '100%',
              maxWidth: isMobile ? '240px' : '300px',
              height: 'auto',
              objectFit: 'contain',
              filter: 'brightness(1.1)'
            }}
          />
        </div>
        <p
          style={{
            marginTop: isMobile ? '20px' : '16px',
            maxWidth: isMobile ? '100%' : '900px',
            textAlign: 'center',
            fontSize: isMobile ? '11px' : '12px',
            lineHeight: 1.5,
            color: '#4b5563',
            padding: isMobile ? '0 10px' : '0',
            wordWrap: 'break-word',
            overflowWrap: 'break-word'
          }}
        >
          This work was supported by the PRIMA Programme, supported by the European Union, under grant agreement NºANR-25-PRIM-0010.
        </p>
      </div>

      <footer id="jet-theme-core-footer" class="jet-theme-core-location jet-theme-core-location--footer-location"><div class="jet-theme-core-location__inner">		<div data-elementor-type="jet_footer" data-elementor-id="4660" class="elementor elementor-4660">
  <section class="elementor-section elementor-top-section elementor-element elementor-element-15e8b0d elementor-section-full_width elementor-section-height-default elementor-section-height-default" data-id="15e8b0d" data-element_type="section" data-settings="{&quot;jet_parallax_layout_list&quot;:[{&quot;jet_parallax_layout_image&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;_id&quot;:&quot;e4d8545&quot;,&quot;jet_parallax_layout_image_tablet&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_image_mobile&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_speed&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:50,&quot;sizes&quot;:[]},&quot;jet_parallax_layout_type&quot;:&quot;scroll&quot;,&quot;jet_parallax_layout_direction&quot;:null,&quot;jet_parallax_layout_fx_direction&quot;:null,&quot;jet_parallax_layout_z_index&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x&quot;:50,&quot;jet_parallax_layout_bg_x_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y&quot;:50,&quot;jet_parallax_layout_bg_y_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size&quot;:&quot;auto&quot;,&quot;jet_parallax_layout_bg_size_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_animation_prop&quot;:&quot;transform&quot;,&quot;jet_parallax_layout_on&quot;:[&quot;desktop&quot;,&quot;tablet&quot;]}]}">
<div class="elementor-container elementor-column-gap-default">
<div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-de10d43" data-id="de10d43" data-element_type="column">
<div class="elementor-widget-wrap elementor-element-populated">
<section class="elementor-section elementor-inner-section elementor-element elementor-element-d900945 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="d900945" data-element_type="section" data-settings="{&quot;jet_parallax_layout_list&quot;:[{&quot;jet_parallax_layout_image&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;_id&quot;:&quot;09e1246&quot;,&quot;jet_parallax_layout_image_tablet&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_image_mobile&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_speed&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:50,&quot;sizes&quot;:[]},&quot;jet_parallax_layout_type&quot;:&quot;scroll&quot;,&quot;jet_parallax_layout_direction&quot;:null,&quot;jet_parallax_layout_fx_direction&quot;:null,&quot;jet_parallax_layout_z_index&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x&quot;:50,&quot;jet_parallax_layout_bg_x_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y&quot;:50,&quot;jet_parallax_layout_bg_y_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size&quot;:&quot;auto&quot;,&quot;jet_parallax_layout_bg_size_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_animation_prop&quot;:&quot;transform&quot;,&quot;jet_parallax_layout_on&quot;:[&quot;desktop&quot;,&quot;tablet&quot;]}]}">
<div class="elementor-container elementor-column-gap-default">
<div class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-80aa1ca" data-id="80aa1ca" data-element_type="column">
<div class="elementor-widget-wrap elementor-element-populated">
<div class="elementor-element elementor-element-c8e2118 elementor-widget elementor-widget-jet-logo" data-id="c8e2118" data-element_type="widget" data-widget_type="jet-logo.default">
<div class="elementor-widget-container">
<div class="elementor-jet-logo jet-blocks"><div class="jet-logo jet-logo-type-image jet-logo-display-block footer-logo-slot">
<Link to="/" class="jet-logo__link" onClick={scrollToTop}><img src={medagricycleLogo} class="jet-logo__img footer-logo-img" alt="MedAgriCycle" width={90} height={90} decoding="sync" /></Link></div>
</div>		</div>
</div>
<div class="elementor-element elementor-element-1ed5b4b elementor-widget__width-initial elementor-widget elementor-widget-text-editor footer-description" data-id="1ed5b4b" data-element_type="widget" data-widget_type="text-editor.default"><div class="elementor-widget-container" style={{fontSize: '14px', lineHeight: '1.5', color: '#ffffff', padding: '0'}}>{siteDescription}</div></div>
<div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
  <img
    alt="PRIMA Logo"
    src={primaLogoFooter}
    style={{
      maxHeight: isMobile ? '40px' : '50px',
      width: '300px',
      height: '300px',
      objectFit: 'contain',
      filter: 'brightness(1.1)'
    }}
  />
</div>
</div>
</div>
<div class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-4b41db1" data-id="4b41db1" data-element_type="column">
<div class="elementor-widget-wrap elementor-element-populated">
<div class="elementor-element elementor-element-ed2e045 elementor-widget elementor-widget-heading" data-id="ed2e045" data-element_type="widget" data-widget_type="heading.default">
<div class="elementor-widget-container">
<h2 class="elementor-heading-title elementor-size-default" style={{fontSize: '18px', color: '#96ca2d', fontFamily: 'Inter, sans-serif', fontWeight: '700'}}>{t('footer.contactUs')}</h2>		</div>
</div>
<div class="elementor-element elementor-element-e7dcfa2 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list" data-id="e7dcfa2" data-element_type="widget" data-widget_type="icon-list.default">
<div class="elementor-widget-container">
<ul class="elementor-icon-list-items">
<li class="elementor-icon-list-item">
      <a href={`mailto:${contactEmail}`} style={{color: '#ffffff', fontSize: '14px', fontFamily: 'Inter, sans-serif'}}>

        <span class="elementor-icon-list-icon">
<i aria-hidden="true" class="fas fa-envelope"></i>						</span>
    <span class="elementor-icon-list-text" style={{color: '#ffffff', fontSize: '14px', fontFamily: 'Inter, sans-serif'}}>{contactEmail}</span>
      </a>
  </li>
<li class="elementor-icon-list-item">
      <a href={`tel:${contactPhone.replace(/\s/g, '')}`} style={{color: '#ffffff', fontSize: '14px', fontFamily: 'Inter, sans-serif'}}>

        <span class="elementor-icon-list-icon">
<i aria-hidden="true" class="fas fa-phone-alt"></i>						</span>
    <span class="elementor-icon-list-text" style={{color: '#ffffff', fontSize: '14px', fontFamily: 'Inter, sans-serif'}}>{contactPhone}</span>
      </a>
  </li>
</ul>
</div>
</div>
  {/*
<div class="elementor-element elementor-element-fcd5c91 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list" data-id="fcd5c91" data-element_type="widget" data-widget_type="icon-list.default">
<div class="elementor-widget-container">
<ul class="elementor-icon-list-items">
<li class="elementor-icon-list-item">
      <span class="elementor-icon-list-icon">
<i aria-hidden="true" class="fas fa-home"></i>						</span>
    <span class="elementor-icon-list-text" style={{color: '#ffffff', fontSize: '14px', fontFamily: 'Inter, sans-serif'}}>Mediterranean Region<br/>European Union</span>
  </li>
</ul>
</div>
</div>*/ }
</div>
</div>
<div class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-e0d7d2d" data-id="e0d7d2d" data-element_type="column">
<div class="elementor-widget-wrap elementor-element-populated">
<div class="elementor-element elementor-element-ed25417 jet-nav-align-flex-start elementor-widget elementor-widget-jet-nav-menu" data-id="ed25417" data-element_type="widget" data-widget_type="jet-nav-menu.default">
<div class="elementor-widget-container">
<nav class="jet-nav-wrap m-layout-mobile"><div class="menu-footer-menu-container"><div class="jet-nav m-layout-mobile jet-nav--vertical jet-nav--vertical-sub-right-side">
<div class="menu-item menu-item-type-post_type menu-item-object-page jet-nav__item"><Link to="/" class="menu-item-link menu-item-link-depth-0 menu-item-link-top" onClick={scrollToTop} style={{ color: '#ffffff', fontSize: '14px', fontFamily: 'Inter, sans-serif' }}><span class="jet-nav-link-text" style={{ color: '#ffffff', fontSize: '14px', fontFamily: 'Inter, sans-serif' }}>{t('footer.home')}</span></Link></div>
<div class="menu-item menu-item-type-post_type menu-item-object-page jet-nav__item"><Link to="/about" class="menu-item-link menu-item-link-depth-0 menu-item-link-top" onClick={scrollToTop} style={{ color: '#ffffff', fontSize: '14px', fontFamily: 'Inter, sans-serif' }}><span class="jet-nav-link-text" style={{ color: '#ffffff', fontSize: '14px', fontFamily: 'Inter, sans-serif' }}>{t('footer.about')}</span></Link></div>
<div class="menu-item menu-item-type-post_type menu-item-object-page jet-nav__item"><Link to="/workpackages" class="menu-item-link menu-item-link-depth-0 menu-item-link-top" onClick={scrollToTop} style={{ color: '#ffffff', fontSize: '14px', fontFamily: 'Inter, sans-serif' }}><span class="jet-nav-link-text" style={{ color: '#ffffff', fontSize: '14px', fontFamily: 'Inter, sans-serif' }}>{t('footer.workPackages')}</span></Link></div>
<div class="menu-item menu-item-type_post_type menu-item-object-page jet-nav__item"><Link to="/events" class="menu-item-link menu-item-link-depth-0 menu-item-link-top" onClick={scrollToTop} style={{ color: '#ffffff', fontSize: '14px', fontFamily: 'Inter, sans-serif' }}><span class="jet-nav-link-text" style={{ color: '#ffffff', fontSize: '14px', fontFamily: 'Inter, sans-serif' }}>{t('footer.events')}</span></Link></div>
<div class="menu-item menu-item-type_post_type menu-item-object-page jet-nav__item"><Link to="/partners" class="menu-item-link menu-item-link-depth-0 menu-item-link-top" onClick={scrollToTop} style={{ color: '#ffffff', fontSize: '14px', fontFamily: 'Inter, sans-serif' }}><span class="jet-nav-link-text" style={{ color: '#ffffff', fontSize: '14px', fontFamily: 'Inter, sans-serif' }}>{t('footer.partners')}</span></Link></div>
<div class="menu-item menu-item-type_post_type menu-item-object-page jet-nav__item"><Link to="/news" class="menu-item-link menu-item-link-depth-0 menu-item-link-top" onClick={scrollToTop} style={{ color: '#ffffff', fontSize: '14px', fontFamily: 'Inter, sans-serif' }}><span class="jet-nav-link-text" style={{ color: '#ffffff', fontSize: '14px', fontFamily: 'Inter, sans-serif' }}>{t('footer.news')}</span></Link></div>
<div class="menu-item menu-item-type_post_type menu-item-object-page jet-nav__item"><Link to="/contact" class="menu-item-link menu-item-link-depth-0 menu-item-link-top" onClick={scrollToTop} style={{ color: '#ffffff', fontSize: '14px', fontFamily: 'Inter, sans-serif' }}><span class="jet-nav-link-text" style={{ color: '#ffffff', fontSize: '14px', fontFamily: 'Inter, sans-serif' }}>{t('footer.contact')}</span></Link></div>
</div></div></nav>		</div>
</div>
</div>
</div>
</div>
</section>
<section class="elementor-section elementor-inner-section elementor-element elementor-element-34ac766 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="34ac766" data-element_type="section" data-settings="{&quot;jet_parallax_layout_list&quot;:[{&quot;jet_parallax_layout_image&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;_id&quot;:&quot;09e1246&quot;,&quot;jet_parallax_layout_image_tablet&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_image_mobile&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_speed&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:50,&quot;sizes&quot;:[]},&quot;jet_parallax_layout_type&quot;:&quot;scroll&quot;,&quot;jet_parallax_layout_direction&quot;:null,&quot;jet_parallax_layout_fx_direction&quot;:null,&quot;jet_parallax_layout_z_index&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x&quot;:50,&quot;jet_parallax_layout_bg_x_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y&quot;:50,&quot;jet_parallax_layout_bg_y_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size&quot;:&quot;auto&quot;,&quot;jet_parallax_layout_bg_size_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_animation_prop&quot;:&quot;transform&quot;,&quot;jet_parallax_layout_on&quot;:[&quot;desktop&quot;,&quot;tablet&quot;]}],&quot;background_background&quot;:&quot;classic&quot;}">
<div class="elementor-container elementor-column-gap-default" style={{textAlign: 'center'}}>
<div class="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-3f1a9dd" data-id="3f1a9dd" data-element_type="column">
<div class="elementor-widget-wrap elementor-element-populated" style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
<div class="elementor-element elementor-element-d12cbf9 elementor-widget elementor-widget-text-editor" data-id="d12cbf9" data-element_type="widget" data-widget_type="text-editor.default">
<div class="elementor-widget-container" style={{textAlign: 'center', width: '100%'}}>
<p class="footer-copy" style={{fontSize: '14px', color: '#ffffff', fontFamily: 'Inter, sans-serif', textAlign: 'center', margin: '0 0 12px 0', display: 'block'}}><span class="footer-copy-brand" style={{color: '#96ca2d', fontWeight: '700'}}>{siteName}</span> © 2024. {t('footer.allRightsReserved')}.</p>

						</div>
</div>
</div>
</div>
</div>
</section>
<section class="elementor-section elementor-inner-section elementor-element elementor-element-34ac766 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="34ac766" data-element_type="section" data-settings="{&quot;jet_parallax_layout_list&quot;:[{&quot;jet_parallax_layout_image&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;_id&quot;:&quot;09e1246&quot;,&quot;jet_parallax_layout_image_tablet&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_image_mobile&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_speed&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:50,&quot;sizes&quot;:[]},&quot;jet_parallax_layout_type&quot;:&quot;scroll&quot;,&quot;jet_parallax_layout_direction&quot;:null,&quot;jet_parallax_layout_fx_direction&quot;:null,&quot;jet_parallax_layout_z_index&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x&quot;:50,&quot;jet_parallax_layout_bg_x_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y&quot;:50,&quot;jet_parallax_layout_bg_y_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size&quot;:&quot;auto&quot;,&quot;jet_parallax_layout_bg_size_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_animation_prop&quot;:&quot;transform&quot;,&quot;jet_parallax_layout_on&quot;:[&quot;desktop&quot;,&quot;tablet&quot;]}],&quot;background_background&quot;:&quot;classic&quot;}">
<div class="elementor-container elementor-column-gap-default" style={{textAlign: 'center'}}>
<div class="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-3f1a9dd" data-id="3f1a9dd" data-element_type="column">
<div class="elementor-widget-wrap elementor-element-populated" style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
<div class="elementor-element elementor-element-d12cbf9 elementor-widget elementor-widget-text-editor" data-id="d12cbf9" data-element_type="widget" data-widget_type="text-editor.default">
<div class="elementor-widget-container" style={{textAlign: 'center', width: '100%'}}>
<div style={{
  display: 'flex', 
  justifyContent: 'center', 
  alignItems: 'center', 
  gap: '12px', 
  flexWrap: 'wrap', 
  fontSize: '13px',
  marginTop: '8px',
  color: '#888888',
  width: '100%',
  visibility: 'visible',
  opacity: 1
}}>
  <Link 
    to="/legal-notice" 
    onClick={scrollToTop} 
    style={{
      color: '#888888', 
      textDecoration: 'none', 
      transition: 'color 0.3s ease',
      fontSize: '13px',
      fontFamily: 'Inter, sans-serif'
    }} 
    onMouseEnter={(e) => e.target.style.color = '#96ca2d'} 
    onMouseLeave={(e) => e.target.style.color = '#888888'}
  >
    {t('footer.legalNotice', 'Legal Notice')}
  </Link>
  <Link 
    to="/cookie-policy" 
    onClick={scrollToTop} 
    style={{
      color: '#888888', 
      textDecoration: 'none', 
      transition: 'color 0.3s ease',
      fontSize: '13px',
      fontFamily: 'Inter, sans-serif'
    }} 
    onMouseEnter={(e) => e.target.style.color = '#96ca2d'} 
    onMouseLeave={(e) => e.target.style.color = '#888888'}
  >
    {t('footer.cookiePolicy', 'Cookie Policy')}
  </Link>
 <Link 
    to="/privacy-policy" 
    onClick={scrollToTop} 
    style={{
      color: '#888888', 
      textDecoration: 'none', 
      transition: 'color 0.3s ease',
      fontSize: '13px',
      fontFamily: 'Inter, sans-serif'
    }} 
    onMouseEnter={(e) => e.target.style.color = '#96ca2d'} 
    onMouseLeave={(e) => e.target.style.color = '#888888'}
  >
    {t('footer.privacyPolicy', 'Privacy Policy')}
  </Link>
</div>
						</div>
</div>
</div>
</div>
</div>
</section>
</div>
</div>
</div>
</section>
</div>
</div>  </footer>
    </>
  );
};

export default Footer;

